// extracted by mini-css-extract-plugin
module.exports = {"error-tooltip":"Error_error-tooltip__1JS2H","tooltip-right":"Error_tooltip-right__1gJ__","tooltip-left":"Error_tooltip-left__3PAQ1"};